var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgOpenNewWindowIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5399 15.336C22.8136 15.3414 23.0342 15.562 23.0395 15.8357V23.5003C23.0395 23.7763 22.8158 24 22.5399 24H8.49965C8.2237 24 8 23.7763 8 23.5003V9.5101C8 9.23415 8.2237 9.01045 8.49965 9.01045H15.9245C16.2004 9.01045 16.4241 9.23415 16.4241 9.5101C16.4241 9.78605 16.2004 10.0098 15.9245 10.0098H8.9993V23.0007H22.0402V15.8357C22.0402 15.5597 22.2639 15.336 22.5399 15.336ZM23.9888 8.32093C24.0037 8.38335 24.0037 8.44839 23.9888 8.5108V12.8578C23.9888 13.1337 23.7651 13.3574 23.4892 13.3574C23.2132 13.3574 22.9895 13.1337 22.9895 12.8578V9.71996L15.145 17.5645C15.0497 17.6601 14.9203 17.7141 14.7853 17.7144C14.6535 17.7125 14.5278 17.6586 14.4355 17.5645C14.2439 17.3668 14.2439 17.0527 14.4355 16.855L22.28 9.01045H19.1422C18.8663 9.01045 18.6426 8.78675 18.6426 8.5108C18.6426 8.23485 18.8663 8.01115 19.1422 8.01115H23.4892C23.5516 7.99628 23.6166 7.99628 23.6791 8.01115C23.8237 8.0625 23.9375 8.17629 23.9888 8.32093Z",
    fill: "#414141"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgOpenNewWindowIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/OpenNewWindowIcon.216db53168afd161be571efcf7241d3a.svg";